import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { iStoreActions } from '../../loan-state/core/store-actions.interface';

export interface PartnerNote {
  guid?: string;
  noteGuid?: string;
  partnerGuid?: string;
  loanOfficerNmls?: string;
  note?: string;
  dateInserted?: Date;
  insertedBy?: string;
  dateUpdated?: Date;
  updatedBy?: string;
}

function createInitialState(): PartnerNote {
  return <PartnerNote>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-partner-notes' })
export class PartnerNotesDataStore extends Store<PartnerNote> implements iStoreActions<PartnerNote> {
  private _initValue: PartnerNote = null;
  constructor() {
    super(createInitialState());
  }

  akitaPreUpdate = (model: Readonly<PartnerNote>, updatedModel: PartnerNote) => {
    return updatedModel;
  };

  preInitialize(): void {
    this._initValue = JSON.parse(JSON.stringify(this.getValue()));
  }

  get initialValue() {
    return this._initValue;
  }
}
